import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigModule, I18nModule } from '@spartacus/core';
import { AlfuriaFourthComponent } from './alfuria-fourth/alfuria-fourth.component';
import { AlfuriaFirstComponent } from './alfuria-first/alfuria-first.component';
import { AlfuriaSecondComponent } from './alfuria-second/alfuria-second.component';
import { AlfuriaThirdComponent } from './alfuria-third/alfuria-third.component';
import { RouterModule } from '@angular/router';
import { CmsCommonModule } from '../cms-common/cms-common.module';

@NgModule({
    declarations: [
        AlfuriaFourthComponent,
        AlfuriaFirstComponent,
        AlfuriaSecondComponent,
        AlfuriaThirdComponent,
    ],
    imports: [
        CommonModule,
        RouterModule,
        I18nModule,
        CmsCommonModule,
        ConfigModule.withConfig({
            cmsComponents:{
                AffluriaPortfolioFeatureResource:{
                    component: AlfuriaFirstComponent
                },
                AffluriaKeyFeaturesResource:{
                    component: AlfuriaSecondComponent
                },
                SeqirusAfluriaReferenceComp:{
                    component: AlfuriaThirdComponent
                },
                AffluriaBannerComp:{
                    component: AlfuriaFourthComponent
                }
            }
        })
    ]
})

export class AlfuriaModule { }
